import React from 'react';

const DashaTimeline = ({ dashaData, title = "Dasha Timeline" }) => {
  if (!dashaData || dashaData.length === 0) {
    return <div className="text-white/50 text-center py-4">No dasha data available</div>;
  }

  // Get planet colors
  const planetColors = {
    'Sun': 'bg-yellow-500',
    'Moon': 'bg-blue-300',
    'Mars': 'bg-red-500',
    'Mercury': 'bg-green-400',
    'Jupiter': 'bg-yellow-400',
    'Venus': 'bg-pink-400',
    'Saturn': 'bg-purple-600',
    'Rahu': 'bg-gray-700',
    'Ketu': 'bg-gray-500'
  };

  return (
    <div className="w-full">
      <h3 className="text-cyan-400 text-lg font-medium mb-4">{title}</h3>
      <div className="overflow-x-auto">
        <table className="w-full border-collapse">
          <thead>
            <tr className="bg-indigo-900/30 border-b border-indigo-700/50">
              <th className="text-left p-3 text-indigo-300 font-medium">Mahadasha Lord</th>
              <th className="text-left p-3 text-indigo-300 font-medium">Start Date</th>
              <th className="text-left p-3 text-indigo-300 font-medium">End Date</th>
              <th className="text-center p-3 text-indigo-300 font-medium">Duration (Years)</th>
            </tr>
          </thead>
          <tbody>
            {dashaData.map((dasha, idx) => {
              const planet = dasha.Planet || dasha.lord;
              const startDate = dasha['Start Date'] || dasha.start;
              const endDate = dasha['End Date'] || dasha.end;
              const years = dasha.years || dasha.Years || '-';
              
              return (
                <tr key={idx} className="border-b border-white/10 hover:bg-white/5 transition-colors">
                  <td className="p-3">
                    <div className="flex items-center gap-2">
                      <span className={`w-3 h-3 rounded-full ${planetColors[planet] || 'bg-gray-400'}`}></span>
                      <span className="text-white font-medium">{planet}</span>
                    </div>
                  </td>
                  <td className="p-3 text-green-300">{startDate}</td>
                  <td className="p-3 text-red-300">{endDate}</td>
                  <td className="p-3 text-center text-yellow-300 font-medium">{years}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default DashaTimeline;
